import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useApi } from "../api";
import { SuccessDialog } from "../components/SuccessDialog";
import { ICargo } from "../interfaces";

export const SignUpPage = () => {
  const api = useApi('NFT');
  const navigate = useNavigate();
  const params = useParams();
  const [username, setUsername] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [cfmPassword, setCfmPassword] = useState<string>('');
  const [processing, setProcessing] = useState<boolean>(false);
  return (
    <>
      <div className="py-5" style={{ backgroundColor: '#e6e6e6' }}>
        <div className="container" style={{ maxWidth: '450px' }}>
          <div className="row radius-12 mx-0" style={{ boxShadow: '0px 0px 10px 5px #d7d7d7' }}>
            <div className="col-12 text-center radius-12 bg-white px-4">
              <div className="py-3 fw-bolder txt-26 mt-4">註冊</div>

              <div className="w-100 border-down mb-4"></div>

              <div className="mb-4 fw-normal text-sm text-start mx-0 mx-sm-4">創建您的帳號</div>
              <div id="nickname"></div>
              <div className="d-flex flex-column">
                {/* <div className="loginT">Email</div> */}
                <input type="text" className="border-1 py-2 px-3 mx-0 mx-sm-4 border-slate-400" id="username" value={username} onChange={(e) => {
                  setUsername(e.target.value)
                }} placeholder="輸入您的Email" />
                <div className="p-1"></div>
                {/* <div className="loginT">密碼</div> */}
                <input type="password" className="border-1 py-2 px-3 mx-0 mx-sm-4 border-slate-400 mt-3" id="password" value={password} onChange={((e) => {
                  setPassword(e.target.value)
                })} placeholder="輸入您的密碼" />
                <div className="p-1"></div>
                {/* <div className="loginT">再次輸入您的密碼</div> */}
                <input type="password" className="border-1 py-2 px-3 mx-0 mx-sm-4 border-slate-400 mt-3" id="repassword" value={cfmPassword} onChange={(e) => {
                  setCfmPassword(e.target.value)
                }} placeholder="再次輸入密碼" />
              </div>
              <button id="login-btn" className="bt-buy my-4 py-2 mx-auto" style={{ borderRadius: '1.875rem', width: '68px' }} onClick={() => {
                if (password !== cfmPassword) {
                  return
                }
                setProcessing(true);
                api.registration(username, password, (cargo: ICargo) => {
                  setProcessing(false);
                  if (cargo.returnCode === '000000') {
                    SuccessDialog({ title: "請登入", content: "註冊成功" })
                    navigate(`/web/login/${params.projectCode}`)
                  }
                })
              }}>{processing ? '處理中' : '提交'}</button>

              <div className="text-center mb-3">或透過以下方式登入</div>

              <div className="d-flex justify-center">
                <div className="line cursor-pointer p-1 mx-auto" style={{ borderRadius: '5px' }}>
                  <img src={require("../assets/img/linew.png")} alt="" />
                </div>
              </div>

              <div className="d-flex justify-content-between c576 txt-14 mt-3">
                <div><a href="forget.html">忘記密碼?</a></div>
                <div><a href="/web/login/nft">登入</a></div>
              </div>

              <div className="w-100 border-down mt-3 mb-5"></div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}